import { render } from "./ProductGallery.vue?vue&type=template&id=d174e6e6&scoped=true&ts=true"
import script from "./ProductGallery.vue?vue&type=script&lang=ts"
export * from "./ProductGallery.vue?vue&type=script&lang=ts"

import "./ProductGallery.vue?vue&type=style&index=0&id=d174e6e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d174e6e6"]])

export default __exports__